import styled from 'styled-components';
import TextCropper from '@omilia/text-cropper';

import { getThemeProp } from 'theme';

export const STextCropper = styled(TextCropper)`
  color: ${getThemeProp('colors.white')};
  display: inline-block;
  font-size: 11px;
  height: unset;
  line-height: 100%;
  padding-left: 10px;
  padding-right: 10px;
  text-transform: uppercase;

  &:hover {
    color: ${getThemeProp('colors.white')};
  }
`;

export const SOpenedMenuHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  padding: 4px 0 7.5px 20px;

  .icon-accept {
    color: ${getThemeProp('colors.white')};
    height: 10px;
    margin-bottom: 14px;
    margin-right: 12px;
    width: 10px;

    &:before {
      font-size: 10px;
    }
  }
`;

export const SEmptyProjectTemplate = styled.div`
  background-color: ${getThemeProp('colors.solitudeGrey')};
  border-radius: 2px;
  color: transparent;
  margin: 0 10px;
  width: 70px;
  opacity: 0.1;
`;

export const SVerticalDivider = styled.div`
  border: 0.5px solid ${getThemeProp('colors.chetwodeBlue')};
  height: 22px;
  position: relative;

  &:after {
    content: '';
  }
`;

export const SInnerVerticalDivider = styled(SVerticalDivider)`
  box-sizing: border-box;
  justify-self: flex-end;
  margin-right: 16px;
  width: 1px;
`;

export const SHorizontalDivider = styled.div`
  border: 0.5px solid ${getThemeProp('colors.chetwodeBlue')};
  box-sizing: border-box;
  height: 1px;
  margin-bottom: 5px;
  opacity: 0.26;
  width: 230px;
`;

export const SCurrentProjectName = styled.div`
  box-sizing: border-box;
  padding-right: 10px;
  width: 134.5px;
`;

export const SOpenArrow = styled.div`
  color: ${getThemeProp('colors.solitudeGrey')};
  height: 6px;
  position: relative;
  width: 6px;

  &:after {
    content: ';';
    font-family: 'omilia-nlu-studio-v2';
    font-size: 6px;
    position: absolute;
  }
`;

export const SOpenProjectMenuButton = styled.div`
  align-items: center;
  display: flex;
  padding: 14.5px 15.5px 14.5px 20px;
  cursor: pointer;

  .icon-project {
    color: ${getThemeProp('colors.solitudeGrey')};
    height: 10px;
    position: relative;
    width: 10px;

    &:before {
      font-size: 10px;
      position: absolute;
      right: 0;
    }
  }
`;

export const SSettingsButton = styled.button`
  background-color: unset;
  box-shadow: unset;
  color: ${getThemeProp('colors.solitudeGrey')};
  cursor: pointer;
  height: 16px;
  margin-left: 15.5px;
  min-width: unset;
  padding: unset;
  width: 16px;
  z-index: 1000;

  &:before {
    font-size: 16px;
  }
`;

export const SSettingsInnerMenuButton = styled.button`
  background-color: unset;
  box-shadow: unset;
  cursor: pointer;
  height: 16px;

  color: ${getThemeProp('colors.moonRakerBlue')};
  justify-self: flex-end;
  margin-right: 20px;
  min-width: unset;
  padding: unset;
  width: 16px;

  &:before {
    font-size: 16px;
  }
`;

export const SClosedSearchBarContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const SProjectsMenu = styled.div`
  position: relative;
`;

export const SCurrentProject = styled.div`
  overflow: hidden;
`;
